import { ISignUpFormFields } from '../components/pre-signup-form/pre-signup-form.types';

type EnumPreSignupKeys = keyof ISignUpFormFields;

export const GTM_PRE_SIGNUP_FIELDS: Array<EnumPreSignupKeys> = [
  'cnpj',
  'email',
  'integrator',
  'is_already_online_seller',
  'mobile_phone',
  'name',
];

export const sumTotalLeadFields = (lead: ISignUpFormFields) =>
  GTM_PRE_SIGNUP_FIELDS.reduce((sum: number, key: EnumPreSignupKeys) => {
    const hasTypedValue = !!lead[key];
    return hasTypedValue ? sum + 1 : sum;
  }, 0);
